import { useState } from "react";
import { ghostBtnClass } from "@/components/manufacturing/manufacturingSurfaceClasses";
import { QcPhotoViewer } from "@/components/manufacturing/qc/QcPhotoViewer";

/** Loads photo URLs only while the viewer is open. */
export function QcStoredPhotoLink({
  label,
  load,
  disabled,
}: {
  label: string;
  disabled?: boolean;
  load: () => Promise<{ ok: true; urls: string[] } | { ok: false; error: string }>;
}) {
  const [urls, setUrls] = useState<string[] | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function open() {
    setBusy(true);
    setError(null);
    const res = await load();
    setBusy(false);
    if (!res.ok) {
      setError(res.error);
      return;
    }
    if (res.urls.length === 0) {
      setError("No photo is stored yet.");
      return;
    }
    setUrls(res.urls);
  }

  return (
    <>
      <button type="button" className={ghostBtnClass} disabled={disabled || busy} onClick={() => void open()}>
        {busy ? "Loading photos…" : label}
      </button>
      {error ? <p className="text-sm text-red-700 dark:text-red-300">{error}</p> : null}
      {urls ? <QcPhotoViewer urls={urls} index={0} title={label} onClose={() => setUrls(null)} /> : null}
    </>
  );
}
